module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Launch"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.message || "你无权观看此直播，请联系管理员"))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a3aa7e2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/tipsView.vue
// module id = 391
// module chunks = 0